import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

/*
--------------------------------------------------
  CREATED BY : RAJAN SINGH
  CREATED DATE :09 MARCH 2021
  PURPOSE : TO SHOW NOTIFICATION / ALERTS/ MESSAGES
-----------------------------------------------------
*/


@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private ErrorMessage:string;
  private ErrorTitle:string;
  constructor(private toastr: ToastrService) {
    this.ErrorMessage = "There is some error in the system.";
    this.ErrorTitle = "Error";

  }

  showSuccess(message:string, title:string){
      this.toastr.success(message, title)
  }

  showError(message?:string, title?:string){
      if (message == null || message == ""){
        message = this.ErrorMessage;
      }if (title == null || title == ""){
        title = this.ErrorTitle;
      }



      this.toastr.error(message, title)
  }

  showInfo(message:string, title:string){
      this.toastr.info(message, title)
  }

  showWarning(message:string, title:string){
      this.toastr.warning(message, title)
  }

}